"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scene = void 0;
var GameEngine_1 = require("../Engine/GameEngine");
var GameWall_1 = require("../GameWall");
var LetterBox_1 = require("../Box/LetterBox");
var WordGenerator_1 = require("../WordGenerator");
var matter_js_1 = require("matter-js");
var Util_1 = require("../../util/Util");
var Scene = /** @class */ (function () {
    function Scene(_element, _sceneWidth, _sceneHeight) {
        this._element = _element;
        this._sceneWidth = _sceneWidth;
        this._sceneHeight = _sceneHeight;
        this._letterBoxes = [];
        this._distractions = [];
        this._gameEngine = new GameEngine_1.GameEngine(this._element, this._sceneWidth, this._sceneHeight);
        this._wordGenerator = new WordGenerator_1.WordRandomiser();
        this.buildWalls();
    }
    Scene.prototype.buildWalls = function () {
        // ground, left, right, top
        // width, height, x, y
        this._gameEngine.addMultipleGameObjects([
            new GameWall_1.GameWall(this._sceneWidth * 2, 20, 0, this._sceneHeight, false),
            new GameWall_1.GameWall(1, this._sceneHeight * 2, 0, 400, true),
            new GameWall_1.GameWall(1, this._sceneHeight * 2, this._sceneWidth, this._sceneHeight / 2, true),
            new GameWall_1.GameWall(this._sceneWidth * 2, 100, 0, 0, true)
        ]);
    };
    Scene.prototype.buildBoxesByWord = function (word) {
        this._gameEngine.removeMultipleGameObjects(this._letterBoxes);
        this.buildWord(word);
    };
    Scene.prototype.buildBoxesByRandomWord = function (word) {
        this._gameEngine.removeMultipleGameObjects(this._letterBoxes);
        var randomWord = this._wordGenerator.getRandomisedLettersByWord(word);
        this.buildWord(randomWord);
    };
    Scene.prototype.setBoxSizeByWordLength = function (word) {
        var size = 50;
        if (word.length > 5) {
            size = 45;
        }
        else if (word.length > 7) {
            size = 35;
        }
        return size;
    };
    Scene.prototype.buildWord = function (word) {
        var boxes = [];
        var centerX = this._sceneWidth / 2;
        var centerY = this._sceneHeight / 2;
        var reversedWord = word.split('').reverse().join('');
        var size = this.setBoxSizeByWordLength(reversedWord);
        for (var i = 0; i < reversedWord.length; i++) {
            var letter = reversedWord[i];
            boxes.push(new LetterBox_1.LetterBox(size, size, centerX, centerY, letter.toUpperCase()));
        }
        this._letterBoxes = boxes;
        this._gameEngine.addMultipleGameObjects(boxes);
    };
    Scene.prototype.shuffleBoxes = function () {
        var bodies = this._gameEngine.bodies;
        for (var i = 0; i < bodies.length; i++) {
            var body = bodies[i];
            if (!body.isStatic && body.position.y >= 500) {
                var forceMagnitude = 0.05 * body.mass;
                matter_js_1.Body.applyForce(body, body.position, {
                    x: (forceMagnitude + Util_1.Util.Random(0, 1) * forceMagnitude) * Util_1.Util.Choices([1, -1]),
                    y: -forceMagnitude + Util_1.Util.Random(0, 1) * -forceMagnitude
                });
            }
        }
    };
    Scene.prototype.slowMotionForSeconds = function (seconds) {
        this._gameEngine.slowMotionForSeconds(seconds);
    };
    Scene.prototype.getCombinedWord = function () {
        var boxes = this.letterBoxes.slice(0);
        // Order by lowest to highest Y value
        boxes.sort(function (a, b) {
            return a.y - b.y;
        });
        var boxesConnect = this.checkBoxesConnect(boxes);
        if (boxesConnect === false) {
            // @TODO - What do we want to do here?
            return "";
        }
        var combinedWord = "";
        boxes.map(function (box) {
            combinedWord += box.text;
        });
        return combinedWord.toUpperCase();
    };
    Scene.prototype.checkBoxesConnect = function (boxes) {
        return this._gameEngine.checkBodiesConnect(boxes);
    };
    Object.defineProperty(Scene.prototype, "letterBoxes", {
        get: function () { return this._letterBoxes; },
        enumerable: false,
        configurable: true
    });
    return Scene;
}());
exports.Scene = Scene;
